module.exports = __webpack_public_path__ + "static/media/England.e8dfec46.png";